import React from 'react';
import {
  AzureActionType,
  AzureVmAction,
  VmssAction,
  AzureResourceType,
} from './types';
import { ActionConfirmationDisplay } from '../../types';
import { ActionConfirmationDialog } from '../../ActionConfirmationDialog';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  action: AzureActionType;
  isLoading: boolean;
  service: AzureResourceType;
}

interface DialogConfig {
  title: string;
  content: string;
  actionDisplay: ActionConfirmationDisplay;
}

const getDialogConfig = (
  action: AzureActionType,
  service: AzureResourceType,
): DialogConfig => {
  switch (service) {
    case 'vm': {
      const actionDisplays: Record<AzureVmAction, ActionConfirmationDisplay> = {
        start: { text: 'Start', color: 'primary' },
        stop: { text: 'Stop', color: 'secondary' },
        restart: { text: 'Restart', color: 'primary' },
      };
      const actionDisplay = actionDisplays[action as AzureVmAction];
      const title = `Confirm ${actionDisplay.text} Azure VMs`;
      const content = `Are you sure you want to ${actionDisplay.text.toLowerCase()} Azure VMs?`;
      return { title, content, actionDisplay };
    }
    case 'vmss': {
      const actionDisplays: Record<VmssAction, ActionConfirmationDisplay> = {
        start: { text: 'Start', color: 'primary' },
        stop: { text: 'Stop', color: 'secondary' },
        restart: { text: 'Restart', color: 'primary' },
      };
      const actionDisplay = actionDisplays[action as VmssAction];
      const title = `Confirm ${actionDisplay.text} Azure VMSS`;
      const content = `Are you sure you want to ${actionDisplay.text.toLowerCase()} Azure VMSS?`;
      return { title, content, actionDisplay };
    }
    default: {
      return {
        title: 'Confirm',
        content: `Are you sure you want to execute ${action} action?`,
        actionDisplay: { text: action, color: 'primary' },
      };
    }
  }
};

export const AzureActionConfirmationDialog: React.FC<
  ConfirmationDialogProps
> = ({ open, onClose, onConfirm, action, isLoading, service }) => {
  if (!action) {
    return null;
  }

  const { title, content, actionDisplay } = getDialogConfig(action, service);

  return (
    <ActionConfirmationDialog<AzureActionType>
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      action={action}
      isLoading={isLoading}
      actionDisplay={actionDisplay}
      title={title}
      content={content}
    />
  );
};
